import React, { Suspense, lazy } from 'react';
import { Switch, Route } from 'react-router-dom';

import { Spinner } from 'reactstrap';

const Login = lazy(() => import('../components/Login'));
const ForgotPassword = lazy(() => import('../components/ForgotPassword'));
const ResetPasswordCheckMail = lazy(() => import('../components/ResetPasswordCheckMail'));
const ResetPassword = lazy(() => import('../components/ResetPassword'));
const InviteUser = lazy(() => import('../components/InviteUser'));
const Notfound = lazy(() => import('../components/notfound'));
const PublicRoutes = () => (
  <Suspense
    fallback={
      <center>
        <Spinner />
        <h6 className="mt-3">Please wait...</h6>
      </center>
    }
  >
    <Switch>
      <Route exact path="/login" component={Login} />
      <Route exact path="/forgot-password" component={ForgotPassword} />
      <Route exact path="/reset-password-checkmail" component={ResetPasswordCheckMail} />
      <Route exact path="/add_technician/:email" component={InviteUser} />
      <Route exact path="/reset-password/:id/:token" component={ResetPassword} />
      <Route path="*" component={Login} />
    </Switch>
  </Suspense>
);

export default PublicRoutes;
